/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { EMAIL_AUTHTYPE, ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";


export const EmailConfigurationEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props.item,
        SID: props.item.SID ?? 0,
        Email: props.item?.Email ?? '',
        AppPass: props.item?.AppPass ?? '',
        Service: props.item?.Service ?? '',
        TenantId: props.item?.TenantId ?? '',
        ClientId: props.item?.ClientId ?? '',
        ClientSecret: props.item?.ClientSecret ?? '',
        RefreshToken: props.item?.RefreshToken ?? '',
        Authentication: props.item?.Authentication ? { _id: props.item?.Authentication, Description: utility.getKeyByValue(EMAIL_AUTHTYPE, props.item?.Authentication) } : { _id: EMAIL_AUTHTYPE.appPassword, Description: utility.getKeyByValue(EMAIL_AUTHTYPE, EMAIL_AUTHTYPE.appPassword) },
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [authTypes, setAuthTypes] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        const authRes = Object.keys(EMAIL_AUTHTYPE).map(x => ({
            _id: EMAIL_AUTHTYPE[x],
            Description: x
        }));
        setAuthTypes(authRes);
    };

    const isValid = () => {
        if (!dataItem.Email || dataItem.Email === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.enter_email_error_message}` });
            return false;
        }
        if (dataItem.Email && !new RegExp(/\S+@\S+\.\S+/).test(dataItem.Email)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_email_error_message}` });
            return false;
        }
        if ((Object.keys(dataItem.Authentication).length === 0 || !dataItem.Authentication)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_authentication_error_message}` });
            return false;
        }
        if (dataItem.Authentication && dataItem.Authentication?._id == EMAIL_AUTHTYPE.appPassword && (!dataItem.AppPass || dataItem.AppPass === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_app_pass_error_message}` });
            return false;
        }
        if (dataItem.Authentication && dataItem.Authentication?._id == EMAIL_AUTHTYPE.OAuth2 && (!dataItem.TenantId || dataItem.TenantId === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_tenant_id_error_message}` });
            return false;
        }
        if (dataItem.Authentication && dataItem.Authentication?._id == EMAIL_AUTHTYPE.OAuth2 && (!dataItem.ClientId || dataItem.ClientId === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_client_id_error_message}` });
            return false;
        }
        if (dataItem.Authentication && dataItem.Authentication?._id == EMAIL_AUTHTYPE.OAuth2 && (!dataItem.ClientSecret || dataItem.ClientSecret === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_client_secret_error_message}` });
            return false;
        }
        if (dataItem.Authentication && dataItem.Authentication?._id == EMAIL_AUTHTYPE.OAuth2 && (!dataItem.RefreshToken || dataItem.RefreshToken === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_refresh_token_error_message}` });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;
        let saveData = {
            _id: dataItem._id,
            SID: dataItem.SID ?? 0,
            Email: dataItem?.Email,
            AppPass: dataItem?.AppPass,
            Service: dataItem?.Service ?? "gmail",
            TenantId: dataItem?.TenantId,
            ClientId: dataItem?.ClientId,
            ClientSecret: dataItem?.ClientSecret,
            RefreshToken: dataItem?.RefreshToken,
            Authentication: Object.keys(dataItem.Authentication).length > 0 ? dataItem.Authentication._id : ''
        }
        console.log(saveData);

        let res = await API.saveData(ENTITYNAME.EmailConfiguration, saveData);
        if (res.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.EmailConfiguration);
            props.cancelEdit();
            props.refresh();
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

    }

    return (
        <BossDialog
            title={props.item.SID > 0 ? props.item.Email : lang.create_email_configuration_dialog_header}
            onClose={props.cancelEdit}
            width={"600px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.email_label} *</label>
                    <input
                        name={"Email"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Email}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.authentication_label} *</label>
                    <DropDownList
                        data={authTypes}
                        name="Authentication"
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onChange}
                        value={dataItem.Authentication}
                        style={{ backgroundColor: 'white', height: '32px' }}
                    />
                </div>
            </div>
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.service_label}</label>
                    <input
                        name={"Service"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Service}
                    />
                </div>
                {dataItem.Authentication && dataItem.Authentication._id == EMAIL_AUTHTYPE.appPassword && <div className='col-6'>
                    <label>{lang.app_pass_label} *</label>
                    <input
                        type="password"
                        name="AppPass"
                        value={dataItem.AppPass}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>}
                {dataItem.Authentication && dataItem.Authentication._id == EMAIL_AUTHTYPE.OAuth2 && <div className='col-6'>
                    <label>{lang.tenant_id_label} *</label>
                    <input
                        type="text"
                        name="TenantId"
                        value={dataItem.TenantId}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>}
            </div>
            {dataItem.Authentication && dataItem.Authentication._id == EMAIL_AUTHTYPE.OAuth2 && <div className="row mt-2 form-group">
                <div className='col-6'>
                    <label>{lang.client_id_label} *</label>
                    <input
                        type="text"
                        name="ClientId"
                        value={dataItem.ClientId}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
                <div className='col-6'>
                    <label>{lang.client_secret_value_label} *</label>
                    <input
                        type="text"
                        name="ClientSecret"
                        value={dataItem.ClientSecret}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
            </div>}
            {dataItem.Authentication && dataItem.Authentication._id == EMAIL_AUTHTYPE.OAuth2 && <div className="row mt-2 form-group">
                <div className='col-6'>
                    <label>{lang.refresh_token_label} *</label>
                    <input
                        type="text"
                        name="RefreshToken"
                        value={dataItem.RefreshToken}
                        onChange={onChange}
                        className="form-control form-control-sm"
                    />
                </div>
            </div>}
        </BossDialog>)
};